import React from 'react'
import { twMerge } from 'tailwind-merge'

type RadioProps = {
  isChecked?: boolean
  name: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const Radio = ({ name, isChecked = false, onChange }: RadioProps) => {
  return (
    <label className="flex cursor-pointer items-center gap-2" htmlFor={name}>
      <input
        name={name}
        type="radio"
        checked={isChecked}
        onChange={onChange}
        className="peer sr-only"
      />
      <span
        className={twMerge(
          'flex h-5 w-5 items-center justify-center rounded-full border-2 border-gray-200 transition-colors',
          'outline-borderInteractive/20 hover:border-blue-500 focus:outline-4',
          isChecked &&
            'border-blue-500 bg-blue-500 hover:border-blue-600 hover:bg-blue-600',
        )}
      >
        {isChecked && <span className="h-2 w-2 rounded-full bg-white" />}
      </span>
    </label>
  )
}
